import axios from 'axios'
// import Vuetify from 'vuetify'

/**
 * Per accedere globalmente a questo modulo usare rootState, rootGetters negli altri moduli
 * 
 * Esempio:
 * getters: {
 *  getRoute(state, getters, rootState) {
 *    return rootState.route;
 *   }
 * }
 */

export default {
	namespaced: true,
	
	state: {
		accountManagersIds: {
			default: [],
			valueNonApplied: [],
			value: []
		}
	},

	getters: {
		accountManagersIds(state) {
			return state.accountManagersIds;
		}
	},

	mutations: { // è il setter dello store, è sincrona, quindi meglio non usarla per fare chiamate api
		SET_ACCOUNT_MANAGERS_IDS_NOT_APPLIED(state, value) {
			state.accountManagersIds.valueNonApplied = value;
		},
		SET_ACCOUNT_MANAGERS_IDS_APPLIED(state, value) {
			state.accountManagersIds.value = value;
		}
	},

	actions: { // sono asincrone, posso fare chiamate api e richiamare poi la mutation
	
	}
}

// export default {
// 	namespaced: true,
// 	state,
// 	getters,
// 	mutations,
// 	actions
// }